import { z } from "zod";
import { toast } from "sonner";

import { BaseForm, FormInput } from "components/BaseForm";
import ProductLineService from "services/ProductLine";

const schema = z.object({
  name: z.string().min(1, "Name is required"),
});

function ProductLineForm({ model, onSuccess }) {
  const handleSubmit = async values => {
    const data = { name: values.name };
    if (model?.id) {
      await ProductLineService.update(model.id, data);
    } else {
      await ProductLineService.create(data);
    }
    toast.success("Product Line saved");
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{ name: model?.name ?? "" }}
      onSubmit={handleSubmit}
      onSuccess={onSuccess}
    >
      <FormInput name="name" label="Name" required autoFocus />
    </BaseForm>
  );
}

export default ProductLineForm;
